export const version = '2.50.3';
//# sourceMappingURL=version.js.map